import * as React from "react";
import "./widget.css";
import { UserLoginData } from "../../TypeScript/interfaces";
import { AxiosResponse, AxiosError } from "axios";
import api from "../../axios/axios";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setDisplayBOList: React.Dispatch<React.SetStateAction<boolean>>;
  setUserLoginData: React.Dispatch<React.SetStateAction<UserLoginData>>;
  userLoginData: UserLoginData;
}

const WidgetLogin: React.FC<Props> = (props) => {
  const { setSelectedPage, setDisplayBOList, setUserLoginData, userLoginData } =
    props;


  const { fileUploadData, setUploadData } = useFileUploadInfoData();    
  const handleLogin = () => {
    setSelectedPage("LoginScreen");
  };

  const handleLogout = () => {
    api
      .post("/bol-gui/v1/bol/logout")      
      .then((response: AxiosResponse) => {        
        setSelectedPage("Logout");
        setDisplayBOList(false);
        setUserLoginData({
          salutation: "",
          firstName: "",
          lastName: "",
          email: "",
          userType: "",
          customerOrg: "",
          phoneNbr: "",
        });
      })
      .catch((error: AxiosError) => {
        console.log(JSON.stringify(error, null, 2));
        setUploadData({
          ...fileUploadData,
          returnedError: "UnexpectedError"
        });
        setSelectedPage("ErrorPage");
    });
  };

  return (
    <section className="widget">
      <h2>Login</h2>
      <div>
        <ul className="widget-content">
          {userLoginData.firstName && (
            <>
              Welcome {userLoginData.firstName} {userLoginData.lastName}.
              <br />
              You are logged in as a <strong>Premium User.</strong>
              <br />
              <li>
                <a
                  href="https://www.clearstream.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="To see your profile and account settings you will be redirected to Clearstream's website"
                >
                  My Profile
                </a>
              </li>
              <li>
                <button className="buttonaslink" onClick={handleLogout}>
                  Logout
                </button>
              </li>
              If you are not{" "}
              <strong>
                {userLoginData.firstName} {userLoginData.lastName}
              </strong>
              <li>
                <button className="buttonaslink" onClick={handleLogin}>
                  click here.
                </button>
              </li>
            </>
          )}
          {!userLoginData.firstName && (
            <>
              <li>
                <button className="buttonaslink" onClick={handleLogin}>
                  Login
                </button>
              </li>
              <li>
                <a
                  href="https://www.clearstream.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="You will be redirected to Clearstream's website where you can register for an account"
                >
                  Register
                </a>
              </li>
              <li>
                <a
                  href="https://www.clearstream.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="If you forgot your password go to Clearstream's website to recover it"
                >
                  Recover Password
                </a>
              </li>
            </>
          )}
        </ul>
      </div>
    </section>
  );
};

export default WidgetLogin;
